export const addComma = (price: number) => {
  return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

/**
 * 이름의 중간 부분을 *로 마스킹한다.
 * - 1자리: 그대로 반환
 * - 2자리: 끝 글자를 * 처리 (예: 김* )
 * - 3자리 이상: 첫 글자와 끝 글자를 제외한 중간을 * 처리 (예: 김*삼, 김**사)
 */
export const maskName = (name: string): string => {
  if (name.length <= 1) return name;
  if (name.length === 2) return name[0] + '*';
  const maskedMiddle = '*'.repeat(name.length - 2);
  return name[0] + maskedMiddle + name[name.length - 1];
}